const Category = (api: any)=>({
    getCategories: () =>
        api.get('/category/getCategories.php', {},{}),
    
});

export default Category;